module.exports = __webpack_public_path__ + "img/generic_01_1280.af718a3f.jpg";